import React, {Component} from "react"
import {Row, Col} from "react-bootstrap"

import withBranding, {WithBranding} from "@irati/brand/withBranding"
import {Deal} from "@irati/types"
import {getBannerImage, getColorFromThumbnail} from "@irati/utils/images"
import {determineDealColor} from "@irati/deals/helpers/deals/appearance"
import tracking from "@irati-tracking/perks/perks"
import Flex from "@irati/ui/src/Flex"
import Spacing from "@irati/ui/src/Spacing"
import isRPDeal from "@irati/deals/helpers/deals/isRPDeal"

import DEAL_PAGES from "../../constants/dealPage"
import dealDefaultBanner from "../../images/dealDefaultBanner.png"
import FavouriteIconButton, {FavouriteButtonOnChange} from "../Favourite/IconButton"
import FullWidthBanner from "./FullWidthBanner"

interface Props extends WithBranding {
  deal: Deal,
  showFavouriteIcon?: boolean
}

interface State {
  dealColor?: string
}

class LayoutDealsInfo extends Component<Props, State> {
  state: State = {}

  componentDidMount() {
    if (!this.props.deal.bannerImage) {
      getColorFromThumbnail(this.props.deal.thumbnailImage).then((dealColor) => {
        this.setState({dealColor})
      })
    }
  }

  get brandColor(): string {
    const {businessLogoUrl, primaryColour} = this.props.branding
    return determineDealColor(this.props.deal, businessLogoUrl, primaryColour)
  }

  handleFavChange: FavouriteButtonOnChange = (isFavourite: boolean) => {
    const func = isFavourite ? tracking.favouritePerk : tracking.unfavouritePerk
    func(this.props.deal, DEAL_PAGES.PERK)
  }

  render() {
    const {deal, showFavouriteIcon = true} = this.props
    const {dealColor} = this.state
    const bannerImageSrc = deal.bannerImage ? getBannerImage(deal.bannerImage) : dealDefaultBanner
    return (
      <>
        {dealColor ? (
          <FullWidthBanner color={dealColor} useImgTag={false} />
        ) : (
          <FullWidthBanner src={bannerImageSrc} color={this.brandColor} />
        )}
        <Row style={{minHeight: 75}}>
          {showFavouriteIcon && !isRPDeal(deal) && (
            <Col xs={12} mdHidden lgHidden>
              <Flex justifyContent="flex-end">
                <Spacing margin={2}>
                  <FavouriteIconButton deal={deal} onChange={this.handleFavChange} />
                </Spacing>
              </Flex>
            </Col>
          )}
        </Row>
      </>
    )
  }
}

export default withBranding(LayoutDealsInfo)
